import { useQuery } from '@tanstack/react-query';
import { api } from './client';
import { QUERY_KEYS } from '@/lib/constants';
import type { ApiResponse, StatsOverview, SceneStats, StatsRetention, StatsProgress, MasteryCurvePoint, SkillLevel } from './types';

export function useStatsOverview() {
  return useQuery({
    queryKey: QUERY_KEYS.stats.overview(),
    queryFn: () => api.get<ApiResponse<StatsOverview>>('/api/v1/stats/overview'),
    select: (res) => res.data,
  });
}

export function useStatsScenes() {
  return useQuery({
    queryKey: QUERY_KEYS.stats.scenes,
    queryFn: () => api.get<ApiResponse<SceneStats[]>>('/api/v1/stats/scenes'),
    select: (res) => res.data,
  });
}

export function useStatsRetention(days = 30) {
  return useQuery({
    queryKey: QUERY_KEYS.stats.retention(days),
    queryFn: () => api.get<ApiResponse<StatsRetention>>(`/api/v1/stats/retention?days=${days}`),
    select: (res) => res.data,
  });
}

export function useStatsProgress(days = 30) {
  return useQuery({
    queryKey: QUERY_KEYS.stats.progress(days),
    queryFn: () => api.get<ApiResponse<StatsProgress>>(`/api/v1/stats/progress?days=${days}`),
    select: (res) => res.data,
  });
}

export function useStatsMasteryCurve(days: number) {
  return useQuery({
    queryKey: ['stats', 'mastery-curve', days],
    queryFn: () => api.get<ApiResponse<MasteryCurvePoint[]>>(`/api/v1/stats/mastery-curve?days=${days}`),
    select: (res) => res.data,
  });
}

export function useStatsSkillLevel() {
  return useQuery({
    queryKey: ['stats', 'skill-level'],
    queryFn: () => api.get<ApiResponse<SkillLevel>>('/api/v1/stats/skill-level'),
    select: (res) => res.data,
  });
}
